import { Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";

export default function NoResultsState() {
  return (
    <Stack
      direction="column"
      align="center"
      justify="center"
      className="al-py-12 al-border al-border-gray-200 al-rounded-md"
    >
      <Typography variant="body" className="al-text-gray-500">
        No learnings found. Try adjusting your search or filters.
      </Typography>
    </Stack>
  );
}
